const content = `
<p class="ql-align-center">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      迭代生效时间：2020年6月15日
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    特别提示：
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    【审慎阅读】
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    <u>
      图灵深视（北京）科技有限公司
    </u>
  </strong>
  （以下统称“包小鉴App/字节跳动小程序/包小鉴H5”或“平台”）在此特别提醒：
  <strong>
    <u>
      在您注册成为用户（包括买家和卖家，以及使用包小鉴App/字节跳动小程序/包小鉴H5服务的其他用户，以下简称“用户”或“您”）之前，请认真阅读本《用户协议》（以下简称“本协议”），特别是免除或者限制责任的条款、法律适用和争议解决条款等以粗体划线重点标识的条款。
    </u>
  </strong>
  如果您对本协议的内容有任何疑问，请向包小鉴App/字节跳动小程序/包小鉴H5客服咨询。
</p>
<p>
  <strong>
    <u>
      【签约动作】
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
    </u>
  </strong>
  <strong>
    <u>
      当您按照注册或登录页面提示填写信息、阅读并同意本协议且完成全部注册或登录程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与平台就本协议达成一致，成为包小鉴App/字节跳动小程序/包小鉴H5用户。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册或登录。
    </u>
  </strong>
</p>
<p>
  <strong>
    【争议解决】
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
    </u>
  </strong>
  本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。
  <strong>
    <u>
      若用户和包小鉴App/字节跳动小程序/包小鉴H5之间发生任何纠纷或争议，首先应友好协商解决。协商不成的，任何一方均可向北京市海淀区人民法院提起诉讼。
    </u>
  </strong>
</p>
<p>
  <strong>
    【版本更新】
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
    </u>
  </strong>
  <u>
    根据国家法律法规变化或平台运营需要，本协议可由包小鉴App/字节跳动小程序/包小鉴H5不时地更新或修改，
  </u>
  <strong>
    <u>
      修改后的协议条款经提前7日公示即生效并代替原来的协议条款，
    </u>
  </strong>
  <u>
    相关内容将公布在本软件等客户端上或以其他方式通知你，您可随时查阅最新版协议条款。
  </u>
  <strong>
    <u>
      在包小鉴App/字节跳动小程序/包小鉴H5修改协议条款后，如果您不接受修改后的条款，请立即停止使用包小鉴App/字节跳动小程序/包小鉴H5提供的服务，您继续使用包小鉴App/字节跳动小程序/包小鉴H5提供的服务将被视为接受修改后的协议。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  <strong>
    一、服务说明
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      1、包小鉴App/字节跳动小程序/包小鉴H5为图灵深视（北京）科技有限公司开发、运营、管理的一款为消费者提供闲置物品网络经营交易场所的软件产品，平台仅就用户在包小鉴App/字节跳动小程序/包小鉴H5展示物品、服务信息、寻找交易对象并完成商品交易提供技术服务，同时为用户提供商品鉴别服务。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      2、平台提供如下两种服务内容：
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    （1）
    <u>
      为买卖双方交易商品提供网络经营场所，即包小鉴App/字节跳动小程序/包小鉴H5利用自身技术能力搭建电商平台供买卖双方进行自由交易，并按照卖家出价页面载明的比例向卖家收取平台技术服务费。
    </u>
  </strong>
</p>
<p>
  <strong>
    <u>
      （2）鉴别查验服务，即包小鉴App/字节跳动小程序/包小鉴H5为用户提供商品查验、包装服务、鉴别服务。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  3、除非本协议另有其他明示规定，平台有权随时强化现有功能或增加任何新功能，包括在包小鉴App/字节跳动小程序/包小鉴H5上推出任何新的服务内容。
</p>
<p class="ql-align-justify">
  <strong>
    &nbsp;
  </strong>
</p>
<p>
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    二、账号注册、使用及安全
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      1、您确认，在您完成注册程序并实际使用服务时，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力，
    </u>
  </strong>
  <strong>
    <u>
      如您不具有前述民事行为能力的，则您应确保您在平台上的任何行为均应事先获得监护人的同意，并由您与您的监护人共同承担不利后果。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      2、包小鉴App/字节跳动小程序/包小鉴H5仅允许每位自然人申请一个账号，
    </u>
  </strong>
  <strong>
    <u>
      如有证据证明或按照后台显示的申请信息证明您不当申请多个账号的，平台有权采取冻结、关闭账号、取消订单或拒绝提供服务等措施。如给平台造成损失的，您应承担赔偿责任。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      3、您应确保在注册及使用平台服务时所填写的信息均真实合法。如您在平台售卖商品应完成实名认证。
    </u>
  </strong>
  <strong>
    <u>
      若您提供任何违法、无效的信息，或提供违法、侵权、不道德或平台认为不适合在平台上展示的资料，或者平台有理由怀疑您的资料属于程序或恶意操作，平台有权冻结、关闭您的帐号、取消您的订单、拒绝您于现在和未来使用包小鉴App/字节跳动小程序/包小鉴H5服务的全部或任何部分，或采取其他合理措施。如给平台造成损失的，您应承担赔偿责任。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      4、
    </u>
  </strong>
  <strong>
    <u>
      平台只允许每位自然人使用一个包小鉴App/字节跳动小程序/包小鉴H5账户，用户完成申请注册手续后，获得包小鉴App/字节跳动小程序/包小鉴H5账户的使用权，该使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖。用户不得恶意注册、不当注册或不当使用包小鉴App/字节跳动小程序/包小鉴H5的账户。若用户有前述情形，包小鉴App/字节跳动小程序/包小鉴H5有权直接采取一切必要措施，取消用户在包小鉴App/字节跳动小程序/包小鉴H5的一切权利、权益，包括但不限于删除发布内容、暂停、查封、冻结账户、取消交易、停止提供服务，注销用户相关信息、收回用户的包小鉴App/字节跳动小程序/包小鉴H5账户、通过诉讼等方式追究用户责任。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      5、您的账户由您自行设置用户名及密码并保管，您应务必保管好您的账户及密码。
    </u>
  </strong>
  <strong>
    <u>
      如果由于您未妥善保管自己的账号和密码而对您或第三方造成任何损失或损害，平台无法也不承担任何法律责任。您应通过司法、行政等救济途径向侵权行为人追偿，并自行向第三方承担法律责任，平台将在行政或司法机关的要求下提供必要的配合及协助。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p>
  6、
  <strong>
    <u>
      您应对您账户下的所有行为及结果负责，包括但不限于发布信息、购买商品或服务、发布社区动态内容、在线签署各类协议等。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      7、您的包小鉴App/字节跳动小程序/包小鉴H5账号遭受未获授权的使用、或者发生其他账号安全问题时，建议您立即通知平台。
    </u>
  </strong>
  <strong>
    <u>
      除包小鉴App/字节跳动小程序/包小鉴H5存在法定过错外，平台不对受理过程中产生的损失扩大承担任何法律责任。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      8、
    </u>
  </strong>
  <strong>
    <u>
      您不得开发或委托第三方开发/使用应用程序侵入平台进行批量数据抓取、下载，平台的Robots协议明令禁止任何数据抓取行为。如平台发现您实施了上述行为，则有权封禁您的账户并扣除您的全部资金，并就平台遭受的全部损失要求您承担赔偿责任。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p>
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    三、服务说明
  </strong>
</p>
<p>
  1、包小鉴App/字节跳动小程序/包小鉴H5及其合作方为买卖双方提供网络经营场所、商品查验及鉴别服务，
  <strong>
    <u>
      因此包小鉴App/字节跳动小程序/包小鉴H5并非商品销售主体。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      2、卖家依法需要取得相关行政许可的，应当依法取得行政许可，并承诺通过包小鉴App/字节跳动小程序/包小鉴H5交易的商品应当符合保障人身、财产安全的要求和环境保护要求，不得销售法律、行政法规禁止交易的商品。如有违反前述约定的，
    </u>
  </strong>
  <strong>
    <u>
      包小鉴App/字节跳动小程序/包小鉴H5有权采取冻结、关闭您的帐号、取消您的订单、拒绝您于现在和未来使用平台服务的全部或任何部分，或采取其他合理措施，并有权向有关主管部门反映。如给平台造成损失的，您应承担赔偿责任。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
    </u>
  </strong>
</p>
<p>
  <strong>
    3、
    <u>
      包小鉴App/字节跳动小程序/包小鉴H5向用户提供出售商品、购买商品的网络经营场所和服务，卖家上架商品时需缴纳相应的费用作为平台服务费（具体见页面详情）。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong>
    4、
    <u>
      当用户选择自主出售商品时，所提交的信息需先由平台进行真实性有效性审核，只有通过审核的商品才会展示在包小鉴App/字节跳动小程序/包小鉴H5中进行销售。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      5、包小鉴App/字节跳动小程序/包小鉴H5希望平台用户遵守契约精神。
    </u>
  </strong>
  <strong>
    <u>
      因此，当卖家出售商品买家提交订单并付款超过2小时犹豫期后，买卖合同即告成立。具体交易规则请仔细阅读《买家须知》与《卖家协议》，买家提交订单的行为则视为买家已仔细阅读并同意接受《买家须知》，卖家确认出售的行为则视为买家已仔细阅读并同意接受《卖家协议》。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      6、用户应当清楚准确地填写送货地址、联系人及联系方式等配送信息。用户知悉并确认，用户所购买的商品应仅由用户填写的联系人接受身份查验后接收商品，因用户变更联系人或相关配送信息而造成的损失由用户自行承担。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  7、卖家在包小鉴App/字节跳动小程序/包小鉴H5出售的商品多为个人闲置物品，
  <strong>
    <u>
      多数情况下出售的同一商品同一型号规格仅为一件，因此卖家无法支持换货，且非商品真假问题无法支持7日无理由退货。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      8、
    </u>
  </strong>
  <strong>
    <u>
      因商品价值较高，用户应使用顺丰快递向平台寄件，并加固商品外包装。如出现使用非指定快递、包装盒破损、运单号无法匹配订单号等情形的快递商品，平台有权进行拒收，如因此造成取消订单、无法退货及相应后果的，平台不承担责任；因快递原因造成的破损、毁损或遗失，用户可与快递协商解决，平台不承担责任，请谨慎选择是否自费保价服务。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong>
    <u>
      9、买家签收时应仔细查验商品，如发现商品（含部件）存在破损、错发或漏发，请签收24小时内提供清晰的照片、订单号向平台客服寻求帮助，并在平台同意退货后3日内将商品、防伪扣连同原包装箱完好退回，防伪扣拆除视为买家认可商品。如买家未在24小时内联系客服或主张质量问题退回的商品符合《买家须知》所述正常质量情况的，则平台无法受理买家退货申请。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      10、
    </u>
  </strong>
  <strong>
    <u>
      包小鉴App/字节跳动小程序/包小鉴H5一直致力于打击假冒伪劣商品。为此，平台依据平台核心技术AI鉴别+人工实物鉴别为买家提供商品鉴别服务。如用户不认同平台的鉴别结果，可在签收24小时内且取防伪扣前与平台客服联系，申请平台认可的第三方鉴别机构出具鉴别报告，如鉴别结果与平台一致，并给包小鉴造成损失的，您应承担相应的赔偿。如果平台出现真假判别有误的情况，平台向买家赔偿十倍鉴别费。因包小鉴App/字节跳动小程序/包小鉴H5并非销售主体，因此该等责任的承担，并不应被视为包小鉴App/字节跳动小程序/包小鉴H5存在售假行为所承担的赔偿责任。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      11、
    </u>
  </strong>
  <strong>
    <u>
      包小鉴App/字节跳动小程序/包小鉴H5抵制利用平台漏洞刷单、套现等获取不正当利益的行为，一经发现用户存在上述行为的，包小鉴App/字节跳动小程序/包小鉴H5有权采取包括但不限于关闭交易订单、封禁用户账号、扣除服务费及账户余额等措施，情节严重的，平台有权移交司法机关处理。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      12、
    </u>
  </strong>
  <strong>
    <u>
      包小鉴App/字节跳动小程序/包小鉴H5为买卖双方提供网络经营场所，但并非货权所有人、亦非商品销售主体，因此不支持向用户开具商品销售发票，也不提供商品维护保养服务。在包小鉴App/字节跳动小程序/包小鉴H5销售商品的多为个人卖家，个人卖家销售闲置商品不支持开具发票。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong>
    四、鉴别说明
  </strong>
</p>
<p>
  1、包小鉴App/字节跳动小程序/包小鉴H5的AI鉴别是从您上传的图片中提取鉴别特征，最终基于图片上的特征进行打分；
</p>
<p>
  2、
  <strong>
    <u>
      远程鉴别都不可避免地存在一定的局限性，不可代替实物鉴别。平台将在现有技术的基础上尽最大努力提供相应的服务，鉴别结果供您参考，平台不承担其他任何责任；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      3、
    </u>
  </strong>
  <strong>
    <u>
      在包小鉴有操作提示的情况下由于您操作不当（包括但不限于：上传的图片未按示例要求拍摄、鉴别品牌选择错误、恶意拼凑图片）导致的鉴别结果偏差，您应自行承担后果；
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      4、
    </u>
  </strong>
  <strong>
    <u>
      包小鉴对本平台的AI鉴别技术有最终解释权。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    <u>
      5、在包小鉴App/字节跳动小程序/包小鉴H5上交易的商品均由AI加人工实物鉴别，最终结果以实物为准。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    五、收费说明
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      1、
    </u>
  </strong>
  <strong>
    <u>
      由卖家个人原因违约导致交易不成功的，卖家需承担对买家的违约费用及平台服务费、平台垫付费用（如有），平台有权扣除相应费用。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    2、
    <u>
      针对正常交易成功的订单，平台对卖家收取平台技术服务费及支付手续费。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    3、
    <u>
      卖家寄到平台的物流费用由卖家自行承担，平台邮寄到买家的物流费用由买家自行承担，如果拒收，平台有权扣除物流费用并终止订单。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong>
    六、内容规范
  </strong>
</p>
<p class="ql-align-justify">
  1、本条所述内容是指用户使用本协议项下服务过程中所制作、上传、复制、发布、传播的任何内容，包括但不限于账号头像、名称、用户评价等信息，或文字、语音、图片、视频、图文等发送、回复或自动回复消息和相关链接页面，以及其他使用账号或本协议项下的服务所产生的内容。
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      2、
    </u>
  </strong>
  <strong>
    <u>
      用户确保在包小鉴App/字节跳动小程序/包小鉴H5发布的内容系用户原创或已获得有效、完整的授权，不会侵犯任何主体的肖像权、名誉权等人身、财产权以及知识产权等合法权益，若因此产生损失和责任，由用户承担。同时，平台有权不经通知，直接立即删除或屏蔽该等内容。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      3、用户应确保通过包小鉴App/字节跳动小程序/包小鉴H5提交、制作、上传、复制、发布、传播的全部信息（包括但不限于个人信息、商品信息、言论及所作出的行为或事件）
    </u>
  </strong>
  <strong>
    <u>
      不含如下内容
    </u>
  </strong>
  ：
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (1) 反对宪法所确定的基本原则的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (3) 损害国家荣誉和利益的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (4) 煽动民族仇恨、民族歧视，破坏民族团结的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (5) 破坏国家宗教政策，宣扬邪教和封建迷信的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (6) 散布谣言，扰乱社会秩序，破坏社会稳定的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (8) 侮辱或者诽谤他人，侵害他人合法权益的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (9) 含有法律、行政法规禁止的其他内容的信息。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      4、
    </u>
  </strong>
  <strong>
    <u>
      用户不得利用包小鉴App/字节跳动小程序/包小鉴H5的账户或本协议项下的服务制作、上载、复制、发布、传播如下干扰平台的正常运营
    </u>
  </strong>
  ，以及侵犯其他用户或第三方合法权益的内容：
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (1) 含有任何性或性暗示的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (2) 含有辱骂、恐吓、威胁内容的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (3) 含有骚扰、垃圾广告、恶意信息、诱骗信息的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (4) 涉及他人隐私、个人信息或资料的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (5) 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (6) 含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      5、
    </u>
  </strong>
  <strong>
    <u>
      一经发现，用户有如上情形，包小鉴App/字节跳动小程序/包小鉴H5有权立即删除或做其他相关处理。如有必要，平台有权将对用户账户做冻结、封禁等处理。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      &nbsp;
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    七、使用规则
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      1、
    </u>
  </strong>
  <strong>
    <u>
      用户可以从App Store、各大应用商城等得到包小鉴App/字节跳动小程序/包小鉴H5授权的第三方上获取包小鉴客户端软件，如果用户从未经包小鉴App/字节跳动小程序/包小鉴H5授权的第三方获取软件或与包小鉴客户端软件名称相同的安装程序，包小鉴App/字节跳动小程序/包小鉴H5无法保证该软件能够正常使用，并对因此给用户造成的损失不予负责。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      2、
    </u>
  </strong>
  <strong>
    <u>
      用户在本协议项下的服务中或通过本协议项下的服务所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表包小鉴App/字节跳动小程序/包小鉴H5的观点、立场或政策，平台对此不承担任何责任。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      3、用户不得利用包小鉴App/字节跳动小程序/包小鉴H5的账户或本协议项下的服务进行如下行为：
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (1) 提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (2) 强制、诱导其他用户关注、点击链接页面或分享信息的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (3) 虚构事实、隐瞒真相以误导、欺骗他人的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (4) 利用技术手段批量建立虚假账号的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (5) 利用包小鉴App/字节跳动小程序/包小鉴H5的账户或本协议项下的服务从事任何违法犯罪活动的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (6) 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (7) 其他违反法律法规规定、侵犯其他用户合法权益、干扰包小鉴App/字节跳动小程序/包小鉴H5正常运营或包小鉴App/字节跳动小程序/包小鉴H5未明示授权的行为。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      4、
    </u>
  </strong>
  <strong>
    <u>
      用户须对利用包小鉴App/字节跳动小程序/包小鉴H5账户或本协议项下的服务传送信息的真实性、合法性、无害性、准确性、有效性等全权负责，与用户所传播的信息相关的任何法律责任由用户自行承担，与包小鉴App/字节跳动小程序/包小鉴H5无关。如因此给包小鉴App/字节跳动小程序/包小鉴H5或第三方造成损害的，用户应当依法予以赔偿。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      5、包小鉴App/字节跳动小程序/包小鉴H5提供的服务中可能包括广告，用户同意在使用过程中显示包小鉴App/字节跳动小程序/包小鉴H5和第三方供应商、合作伙伴提供的广告。除法律法规明确规定外，用户应自行对依该广告信息进行的交易负责，对用户因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，平台不承担任何责任。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    &nbsp;
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    八、提供者的责任
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      1、根据有关法律规定，包小鉴App/字节跳动小程序/包小鉴H5在此郑重提醒您注意，任何经由本协议项下的服务而发布、上传的文字、资讯、资料、音乐、照片、图形、视讯、信息或其它资料（以下简称“内容”），无论系公开还是私下传送，均由内容提供者承担责任。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      2、
    </u>
  </strong>
  <strong>
    <u>
      包小鉴App/字节跳动小程序/包小鉴H5仅为用户提供内容存储空间，无法控制经由本协议项下的服务传送之内容，因此不保证内容的正确性、完整性或品质。您已预知使用本协议项下的服务时，可能会接触到令人不快、不适当或令人厌恶之内容。在任何情况下，平台均不为任何内容负责，但平台有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用本协议项下的服务的全部或部分，保存有关记录，并向有关机关报告。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      &nbsp;
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    九、数据储存
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      1、包小鉴App/字节跳动小程序/包小鉴H5不对用户在本协议项下的服务中相关数据的删除或储存失败负责。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      2、包小鉴App/字节跳动小程序/包小鉴H5在中华人民共和国境内的运营业务收集或产生的数据均存储在中华人民共和国境内服务器。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      3、商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。包小鉴App/字节跳动小程序/包小鉴H5可以根据实际情况依法自行决定用户在本协议项下的服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。用户可根据自己的需要自行备份本协议项下的服务中的相关数据。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      &nbsp;
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    十、风险承担
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      1、
    </u>
  </strong>
  <strong>
    <u>
      本协议项下，包小鉴App/字节跳动小程序/包小鉴H5将按“现状”和“可得到”的状态向用户提供平台服务，将在现有技术的基础上尽最大努力提供相应对的安全措施以保障服务安全和正常运行。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      2、
    </u>
  </strong>
  <strong>
    <u>
      用户理解并同意，用户必须为自己注册账号下的一切行为负责，包括但不限于分享、传送、获取信息、在平台进行商品交易的行为以及由此产生的任何后果。用户应在使用平台过程对自己注册账号下的一切行为自行加以判断，并承担因此引起的所有风险和责任，包括但不限于因正确性、完整性或实用性的依赖而产生的风险。平台无法且不会对因用户行为而导致的任何损失或损害承担责任。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    <u>
      3、如果包小鉴App/字节跳动小程序/包小鉴H5发现或收到他人举报或投诉您违反本协议约定或以其他不当的方式使用本协议项下的服务或存在任何疑似或足以认定为恶意行为的，平台有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁、注销等措施，并公告处理结果。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <br>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      4、
    </u>
  </strong>
  <strong>
    <u>
      包小鉴App/字节跳动小程序/包小鉴H5有权依据合理判断对违反有关法律法规或本协议规定的行为采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应独自承担由此而产生的一切法律责任。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      5、
    </u>
  </strong>
  <strong>
    <u>
      用户理解并同意，因业务发展需要，包小鉴App/字节跳动小程序/包小鉴H5保留单方面对本协议项下的服务的全部或部分服务内容变更、暂停、终止或撤销的权利，但包小鉴App/字节跳动小程序/包小鉴H5将按法律规定提前7日在平台进行公告。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <br>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      6、
    </u>
  </strong>
  <strong>
    <u>
      包小鉴App/字节跳动小程序/包小鉴H5仅作为闲置物品信息发布、鉴别及交易平台，就用户之间的物品交易活动提供平台以展示物品/服务信息、寻找交易对象、就物品/服务的交易提供鉴别服务，除平台另有约定外，平台并不作为交易双方之任何一方的身份参与交易行为，且平台不对用户交易履行能力负责。本协议的签署并不意味着包小鉴App/字节跳动小程序/包小鉴H5为平台上交易双方的行为合法性、有效性提供任何明示或暗示的担保或承诺。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      &nbsp;
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    十一、知识产权声明
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      1、除非另有约定，您通过包小鉴App/字节跳动小程序/包小鉴H5社区发布的用户内容的所有权、知识产权及其他法律权利，归您或您的许可方所有。您同意或者确保实际权利人同意：
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (1)
    </u>
  </strong>
  <strong>
    <u>
      用户同意将在本协议项下的服务中或通过本协议项下的服务所传送、发布的任何内容（包括但不限于文字、语音、图片、视频、图文），授予包小鉴App/字节跳动小程序/包小鉴H5可在全球范围内、免费的、非独家的、可转授权的使用，使用范围包括但不限于在当前或其他网站、应用程序、产品或终端设备等，并授权包小鉴App/字节跳动小程序/包小鉴H5对相应内容可进行修改、复制、改编、翻译、汇编或制作衍生产品。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      (2)
    </u>
  </strong>
  <strong>
    <u>
      用户同意授权包小鉴App/字节跳动小程序/包小鉴H5以公司名义或委托第三方对侵犯用户上传发布的享有知识产权的内容进行维权的权利。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      2、除另有特别声明外，包小鉴App/字节跳动小程序/包小鉴H5提供本协议项下的服务时所依托软件的著作权、专利权及其他知识产权均归包小鉴App/字节跳动小程序/包小鉴H5所有。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      3、包小鉴App/字节跳动小程序/包小鉴H5在本协议项下的服务中所涉及的图形、文字或其组成，以及其他包小鉴App/字节跳动小程序/包小鉴H5标志及产品、服务名称（以下统称“包小鉴App/字节跳动小程序/包小鉴H5标识”）等，其著作权或商标权归包小鉴App/字节跳动小程序/包小鉴H5所有。未经平台事先书面同意，用户不得将平台标识以任何方式展示或使用或作其他处理，也不得向他人表明用户有权展示、使用、或其他有权处理平台标识的行为。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      4、上述及其他任何平台或相关广告商依法拥有的知识产权均受到法律保护，未经平台或相关广告商书面许可，用户不得以任何形式进行使用或创造相关衍生作品。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      &nbsp;
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    十二、法律责任
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      1、
    </u>
  </strong>
  <strong>
    <u>
      如果平台发现或收到他人举报或投诉用户违反本协议约定的，平台有权不经通知随时对相关内容，包括但不限于用户资料、日志、交易记录进行审查、删除，并视情节轻重对违规账号处以包括但不限于警告、账号封禁、设备封禁、功能封禁、删除或屏蔽发布的信息、停止提供服务等处罚。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      2、因违反用户协议或平台规则被封禁的用户不会自动解封。可向平台提交申诉，平台将对申诉进行审查，并自行合理判断决定是否变更处罚措施。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      3、用户理解并同意，平台有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚并公示，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应承担由此而产生的一切法律责任。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      4、
    </u>
  </strong>
  <strong>
    <u>
      用户理解并同意，因用户违反本协议约定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括
    </u>
  </strong>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      但不限于
    </u>
  </strong>
  <strong>
    <u>
      合理的律师费
    </u>
  </strong>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      、诉讼费、执行费等费用
    </u>
  </strong>
  <strong>
    <u>
      ，用户应当赔偿平台及其合作方，并使之免受损害。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      &nbsp;
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    十三、不可抗力及其他免责事由
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      1、
    </u>
  </strong>
  <strong>
    <u>
      用户理解并确认，在使用本协议项下的服务的过程中，可能会遇到不可抗力等风险因素，使本协议项下的服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，平台将努力在第一时间与相关单位配合，及时进行修复，但是由此给用户或第三方造成的损失，平台及合作公司在法律允许的范围内免责。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      2、本协议项下的服务同大多数互联网服务一样，受包括但不限于用户原因、网络服务质量、社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如他人利用用户的资料，造成现实生活中的骚扰；用户下载安装的其它软件或访问的其他网站中含有“特洛伊木马”等病毒，威胁到用户的计算机信息和数据的安全，继而影响本协议项下的服务的正常使用等等。用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，以免遭致损失和骚扰。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      3、
    </u>
  </strong>
  <strong>
    <u>
      用户理解并确认，本协议项下的服务存在因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险，因此导致的用户或第三方任何损失，平台在法律允许的范围内免责。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      4、
    </u>
  </strong>
  <strong>
    <u>
      用户理解并确认，在使用本协议项下的服务过程中存在来自任何他人的包括误导性的、欺骗性的、威胁性的、诽谤性的、令人反感的或非法的信息，或侵犯他人权利的匿名或冒名的信息，以及伴随该等信息的行为，因此导致的用户或第三方的任何损失，平台不承担任何责任。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      5、
    </u>
  </strong>
  <strong>
    <u>
      用户理解并确认，平台需要定期或不定期地对包小鉴App/字节跳动小程序/包小鉴H5或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，平台无需为此承担任何责任，但平台应事先进行通告。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      6、
    </u>
  </strong>
  <strong>
    <u>
      包小鉴App/字节跳动小程序/包小鉴H5依据法律法规、本协议约定获得处理违法违规或违约内容的权利，该权利不构成包小鉴App/字节跳动小程序/包小鉴H5的义务或承诺，平台不能保证及时发现违法违规或违约行为或进行相应处理。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      7、
    </u>
  </strong>
  <strong>
    <u>
      在任何情况下，平台均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因用户使用平台或本协议项下的服务而遭受的利润损失，承担责任（即使平台已被告知该等损失的可能性亦然）。尽管本协议中可能含有相悖的规定，平台对用户承担的全部责任，无论因何原因或何种行为方式，始终不超过用户因使用平台提供的服务而支付给平台的费用(如有)。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      &nbsp;
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    十四、服务的变更、中断、终止
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      1、鉴于网络服务的特殊性，用户同意包小鉴App/字节跳动小程序/包小鉴H5有权随时变更、中断或终止部分或全部的服务（包括收费服务）。包小鉴App/字节跳动小程序/包小鉴H5变更、中断或终止的服务，包小鉴App/字节跳动小程序/包小鉴H5应当在变更、中断或终止之前通知用户，并应向受影响的用户提供等值的替代性的服务；如用户不愿意接受替代性的服务，则用户可以选择停止使用包小鉴App/字节跳动小程序/包小鉴H5提供的服务。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      2、
    </u>
  </strong>
  <strong>
    <u>
      如发生下列任何一种情形，包小鉴App/字节跳动小程序/包小鉴H5有权变更、中断或终止向用户提供的免费服务或收费服务，而无需对用户或任何第三方承担任何责任：
    </u>
  </strong>
</p>
<p class="ql-align-justify">
</p>
<p class="ql-align-justify">
  <strong>
    <u>
      (1) 根据法律规定用户应提交真实信息，而用户提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    <u>
      (2) 用户违反相关法律法规或本平台规则；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    <u>
      (3) 按照法律规定或有权机关的要求；
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    <u>
      (4) 出于安全的原因或其他必要的情形。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      &nbsp;
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong>
    十五、其他
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      1、
    </u>
  </strong>
  <strong>
    <u>
      包小鉴App/字节跳动小程序/包小鉴H5郑重提醒用户注意本协议中免除平台责任和限制用户权利的条款，请用户仔细阅读并理解。未成年人应在法定监护人的陪同下阅读本协议。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      2、本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      3、平台可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”），用户在使用平台服务前请审慎阅读相关的单独协议；用户使用前述服务的，即视为用户已阅读并同意接受相关单独协议，单独协议作为本协议的组成部分，与本协议具有同等法律效力。如二者不一致，应按照单独协议内容执行。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <strong style="color: rgb(20, 21, 26);">
    <u>
      4、
    </u>
  </strong>
  <strong>
    <u>
      本协议内容中以加粗方式显著标识的条款，请您着重阅读。您点击“注册”或“登录”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。
    </u>
  </strong>
</p>
<p>
  <strong>
    <u>
      5、本协议的订立、履行、效力、解释及争议的解决均适用《中华人民共和国合同法》及中华人民共和国其它法律法规。因订立或执行本协议而产生的任何争议，协议双方应首先通过协商解决。若协商不能解决，应提交本协议签订地即北京市海淀区人民法院诉讼。
    </u>
  </strong>
</p>
<p class="ql-align-justify">
  <br>
</p>
<p class="ql-align-center">
  <br>
</p>
`
export default {
  content,
  title: '包小鉴用户协议'
}
